// extracted by mini-css-extract-plugin
export default {"minimap":"lsf-minimap","minimap__region":"lsf-minimap__region","minimap__connection":"lsf-minimap__connection","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630385787
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  